import { SellingCompany } from '../settings';
import { ShipperInterfaceDetails } from './shipper-interface-details';

export interface ShipperInterfaceHeader {
  id: string;
  interfaceNumber: number;
  dateShipped: Date;
  supplierId: string;
  supplierKey: string;
  supplierName: string;
  shipperAccountId: string;
  shipperAccountKey: string;
  shipperAccountWarehouseId: string;
  shippingServiceId: string;
  shippingServiceKey: string;
  shippingServiceDescription: string;
  shippingServiceShippingCost: number;
  salesDespatchNoteId: string;
  shippingCharge: number;
  trackingNumber: string;
  shippingNotes: string;
  deliveryAddressId: string;
  deliveryAddressMultiLine: string;
  deliveryAddresseeId: string;
  deliveryAddressee: string;
  deliveryName: string;
  deliveryLine1: string;
  deliveryLine2: string;
  deliveryLine3: string;
  deliveryLine4: string;
  deliveryTownCity: string;
  deliveryRegion: string;
  deliveryPostCode: string;
  deliveryCountry: string;
  deliveryCountryCode: string;
  deliveryTel: string;
  deliveryEmail: string;
  currencyCode: string;
  totalDeclaredValue: number;
  invoiceNo: number;
  invoiceDate: Date;
  proforma: boolean;
  deliveryVatCode: string;
  deliveryTermId: string;
  deliveryTermKey: string;
  sellingCompanyId: string;
  sellingCompanyName: string;
  pickupName: string;
  pickupLine1: string;
  pickupLine2: string;
  pickupLine3: string;
  pickupLine4: string;
  pickupTownCity: string;
  pickupRegion: string;
  pickupPostCode: string;
  pickupCountryCode: string;
  pickupEmail: string;
  pickupTel: string;
  b2C: boolean;
  eoriNumber: string;
  customerRef1: string;
  customerRef2: string;
  productType: string;

  sellingCompany: SellingCompany;
  shipperInterfaceDetails: ShipperInterfaceDetails[];
}
